const generateHostStoryUrl = (story = {}) => {
  if (global.location) {
    return `${global.location.origin}/${story.slug}`;
  }
};
export default generateHostStoryUrl;
